module.exports = __webpack_public_path__ + "video/700_PAB_2021_WhatToReport.a1c0d8df.vtt";